import { render, staticRenderFns } from "./BookingPassenger.vue?vue&type=template&id=a72497ac"
import script from "./BookingPassenger.vue?vue&type=script&lang=js"
export * from "./BookingPassenger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports